module.exports = __webpack_public_path__ + "img/maquinaria.8bbd052b.svg";